import apiFetch from '../apiFetch'

export default function (token, data, dossierSubtypeId, organizedUnitId) {
  const queryParamsArray = [
    dossierSubtypeId ? `dossierSubtypeId=${dossierSubtypeId}` : null,
    organizedUnitId ? `organizedUnitId=${organizedUnitId}` : null
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )

  return apiFetch({ endPoint: `Fleets/SimulateEconomicPlan${queryParams}`, method: 'POST', body: data, token: token })
}
